export const HEADER_HEIGHT = 50;
export const LEFT_SIDEBAR_WIDTH = 180;
